import { render, staticRenderFns } from "./item-parent.vue?vue&type=template&id=7cb33ff2"
import script from "./item-parent.vue?vue&type=script&lang=js"
export * from "./item-parent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports